import { UseMutationResult, useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";

import { putApplicantsExamsResultsSubmit } from "@api/applicants/applicantsExamsResults";
import { ApiResponse } from "@api/httpClient";

import { useStoreContext } from "@context";

import { ApplicantChallengeResultModel } from "@shared/models";
import { SubmissionType } from "@shared/services/enums";

export interface UseSubmitApplicantsExamsResultsParams {
  examId: number;
  data?: { submissionType: SubmissionType };
}

export const examResultKeys = {
  all: ["APPLICANTS_EXAMS_RESULTS"] as const,
  submit: (challengeResultId: number) =>
    [...examResultKeys.all, "SUBMIT", challengeResultId] as const,
};

export type UseUpdateApplicantsExamResultsMutationResult = UseMutationResult<
  unknown,
  unknown,
  UseSubmitApplicantsExamsResultsParams
>;

export function useSubmitApplicantsExamsResults(challengeResultId: number) {
  const { postSubmitChallenge } = useStoreContext();
  const mutation = useMutation({
    mutationKey: examResultKeys.submit(challengeResultId),
    mutationFn: ({ examId, data }: UseSubmitApplicantsExamsResultsParams) =>
      putApplicantsExamsResultsSubmit({
        challengeResultId,
        examId,
        options: { data },
      }),
    onSuccess: (res: ApiResponse<ApplicantChallengeResultModel>) => {
      if (!res) {
        return;
      }
      postSubmitChallenge(res, true);
    },
    onError: (err: string) => {
      postSubmitChallenge(err, false);
      toast.error(err);
    },
  });

  return mutation;
}
